import { GretaAIChatMessageRole } from '../GretaAIChat.constants'

import { RENDERABLE_ROLES } from './GretaAIChatMessage.constants'

function createGretaAIChatMessage(role, text) {
  return {
    createdAt: new Date().toISOString(),
    id: crypto.randomUUID(),
    isPendingId: true,
    role,
    text,
  }
}

export function getIsGretaAIChatUserRole(role) {
  return role === GretaAIChatMessageRole.User
}

export function getGretaAIChatRenderableTurns(messages) {
  return messages.filter(message => RENDERABLE_ROLES.includes(message.role))
}

export function appendGretaAIChatUserMessage(messages, text) {
  return [
    ...messages,
    createGretaAIChatMessage(GretaAIChatMessageRole.User, text),
  ]
}

export function appendGretaAIChatAssistantMessage(
  messages,
  { reply, suggestSource }
) {
  return [
    ...messages,
    {
      ...createGretaAIChatMessage(GretaAIChatMessageRole.Assistant, reply),
      suggestSource,
    },
  ]
}
